module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 16
// module chunks = 0